// Enum para status do terapeuta
export enum TherapistStatus {
  ACTIVE = 'ativo',
  SUSPENDED = 'suspenso'
}

// Interfaces relacionadas a terapeutas
export interface Therapist {
  id: string;
  nomePublico: string;
  especialidade: string;
  bio: string;
  title: string;
  profilePhotoURL?: string;
  horariosDisponiveis?: Record<string, any>;
  sessionDuration?: number; // duração da sessão em minutos
  certificates?: CertificateEntry[];
  showInShowcase?: boolean; // controla se aparece na vitrine pública
  showcaseAutoManaged?: boolean; // indica se vitrine é gerenciada automaticamente por pagamentos
  lastPaymentStatus?: string; // último status de pagamento (PAYMENT_CONFIRMED, PAYMENT_OVERDUE, etc)
  showcaseUpdatedAt?: any; // última vez que showInShowcase foi alterado
  showcaseUpdatedBy?: 'system' | 'admin'; // quem fez a última alteração na vitrine
}

export interface TherapistData {
  uid?: string;
  name?: string;
  email?: string;
  status?: TherapistStatus;
  creditBalances: {
    sessions?: {
      constellation?: number;
      participation?: number;
    };
    hours?: number;
    updatedAt?: any;
  };
  activeSubscriptions?: {
    constellation?: boolean;  // Tem assinatura ativa para conduzir constelações
    participation?: boolean;  // Tem assinatura ativa para participar
    hours?: boolean;          // Tem assinatura de horas ativa
  };
  horariosDisponiveis?: Record<string, any>;
  pixKey?: string;
  avatar?: string | null;
}

export interface TherapistProfileProps {
  user: { uid: string; [key: string]: any; } | null;
}

export interface CertificateEntry {
  id: number;
  institution: string;
  name: string;
  graduationDate: Date | null;
  file: File | null;
  certificateURL?: string | null;
}